import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "19",
  viewBox: "0 0 20 19",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_213_245)" }, [
      _createElementVNode("path", { d: "M15.7508 0.912781H18.8175L12.1175 8.1882L20 18.0864H13.8283L8.995 12.0824L3.46333 18.0864H0.395L7.56167 10.3043L0 0.913572H6.32833L10.6975 6.40141L15.7508 0.912781ZM14.675 16.3432H16.3742L5.405 2.56499H3.58167L14.675 16.3432Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_213_245" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "19",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }